// import React, { useState, useEffect, useRef } from "react";
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Typography,
//   IconButton,
//   Box,
//   Alert,
// } from '@mui/material';
// import Sidebar from "../../../Navigation/Sidebar/Sidebar";
// import marksatteled from "../../../../assests/marksatteled.svg";
// import CloseIcon from "@mui/icons-material/Close";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import "./ScheduleReport.css";
// import { connect } from "react-redux";
// import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
// import { useNavigate, useParams } from "react-router-dom";
// import { toastr } from "react-redux-toastr";
// import * as XLSX from 'xlsx';
// import debounce from 'lodash/debounce';
// import LoadingSpinner from "../../../Loading/component";

// // Warning icon as inline SVG
// const WarningIcon = () => (
//   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M12 2L1 21H23L12 2Z" stroke="#F59E0B" strokeWidth="1.5" fill="#FEF3C7"/>
//     <path d="M12 9V13" stroke="#F59E0B" strokeWidth="1.5" strokeLinecap="round"/>
//     <circle cx="12" cy="17" r="1" fill="#F59E0B"/>
//   </svg>
// );

// const TruncatedText = ({ text, maxLength = 20 }) => {
//   const [showFullText, setShowFullText] = useState(false);

//   if (!text || text.length <= maxLength) {
//     return <span className="sms-truncated-text">{text || 'N/A'}</span>;
//   }

//   if (showFullText) {
//     return (
//       <span className="sms-truncated-text-full">
//         {text}
//         <button className="sms-see-less-btn" onClick={() => setShowFullText(false)}>
//           See Less
//         </button>
//       </span>
//     );
//   }

//   return (
//     <span className="sms-truncated-text">
//       {text.substring(0, maxLength)}...
//       <button className="sms-see-more-btn" onClick={() => setShowFullText(true)}>
//         See More
//       </button>
//     </span>
//   );
// };

// const ScheduleMarkSettleDownloadReportComponent = ({
//   loading,
//   error,
//   reportData,
//   formatCurrency,
//   onDownloadExcel,
//   onGoBack,
//   onMarkSettle,
//   showMarkSettleDialog,
//   setShowMarkSettleDialog,
//   showSuccessDialog,
//   onSuccessClose,
//   showMismatchDialog,
//   mismatchData,
//   onMismatchCancel,
//   onMismatchUpload,
//   onUploadSettlementFile
// }) => {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploadLoading, setUploadLoading] = useState(false);
//   const [uploadError, setUploadError] = useState(null);
//   const [isDragOver, setIsDragOver] = useState(false);
//   const [localShowSuccessDialog, setLocalShowSuccessDialog] = useState(false);
//   const [localShowMismatchDialog, setLocalShowMismatchDialog] = useState(false);
//   const [fileSelected, setFileSelected] = useState(false);
//   const [showUploadError, setShowUploadError] = useState(false);
//   const [showRetry, setShowRetry] = useState(false);
//   const [showInstructionText, setShowInstructionText] = useState(true);

//   // Create refs for file inputs
//   const fileInputRef = useRef(null);

//   // Handle file selection
//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file && (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
//       setSelectedFile(file);
//       setFileSelected(true);
//       setShowInstructionText(false);
//       setUploadError(null);
//       setShowUploadError(false);
//       setShowRetry(false);
//     } else {
//       setUploadError('Please upload a valid XLS file');
//       setSelectedFile(null);
//       setFileSelected(false);
//     }
//   };

//   // Handle drag events
//   const handleDragOver = (e) => {
//     e.preventDefault();
//     setIsDragOver(true);
//   };

//   const handleDragLeave = (e) => {
//     e.preventDefault();
//     setIsDragOver(false);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setIsDragOver(false);
//     const file = e.dataTransfer.files[0];
//     if (file && (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
//       setSelectedFile(file);
//       setFileSelected(true);
//       setShowInstructionText(false);
//       setUploadError(null);
//       setShowUploadError(false);
//       setShowRetry(false);
//     } else {
//       setUploadError('Please upload a valid XLS file');
//       setSelectedFile(null);
//       setFileSelected(false);
//     }
//   };

//   // Handle file upload
//   const handleFileUpload = async () => {
//     if (!selectedFile) {
//       setUploadError('Please select a file to upload');
//       return;
//     }

//     setUploadLoading(true);
//     setUploadError(null);
//     setShowUploadError(false);

//     const formData = new FormData();
//     formData.append('file', selectedFile);

//     try {
//       const response = await onUploadSettlementFile(formData);
//       setShowMarkSettleDialog(false);
//       setUploadLoading(false);
//       setSelectedFile(null);
//       setFileSelected(false);
//       setShowInstructionText(true);
      
//       // Reset file input value
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
      
//       if (response?.partialMatch || response?.mismatchAmount) {
//         setLocalShowMismatchDialog(true);
//       } else {
//         setLocalShowSuccessDialog(true);
//       }
//     } catch (error) {
//       console.error('Upload error:', error);
//       setUploadError(error.message || 'Failed to upload settlement file');
//       setUploadLoading(false);
//       setShowUploadError(true);
//       setShowRetry(true);
//     }
//   };

//   // Handle retry - only reset to upload area, no API call
//   const handleRetryUpload = () => {
//     // Reset all states to initial
//     setShowUploadError(false);
//     setShowRetry(false);
//     setUploadError(null);
//     setFileSelected(false);
//     setSelectedFile(null);
//     setShowInstructionText(true);
    
//     // Reset file input value safely
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   // Reset dialog state when closed
//   const handleDialogClose = () => {
//     setShowMarkSettleDialog(false);
//     setSelectedFile(null);
//     setFileSelected(false);
//     setUploadError(null);
//     setIsDragOver(false);
//     setShowUploadError(false);
//     setShowRetry(false);
//     setShowInstructionText(true);
    
//     // Reset file input value safely
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   // Handle Mark Settle button click
//   const handleMarkSettleClick = () => {
//     onMarkSettle();
//   };

//   // Handle mismatch cancel
//   const handleMismatchCancel = () => {
//     setLocalShowMismatchDialog(false);
//     if (onMismatchCancel) onMismatchCancel();
//   };

//   // Handle mismatch upload
//   const handleMismatchUpload = () => {
//     setLocalShowMismatchDialog(false);
//     if (onMismatchUpload) onMismatchUpload();
//     setShowMarkSettleDialog(true);
//   };

//   // Handle success close
//   const handleSuccessClose = () => {
//     setLocalShowSuccessDialog(false);
//     if (onSuccessClose) onSuccessClose();
//   };

//   // Get file size in readable format
//   const getFileSize = (bytes) => {
//     if (!bytes) return '';
//     const kb = bytes / 1024;
//     const mb = kb / 1024;
//     if (mb >= 1) {
//       return `${mb.toFixed(1)}MB`;
//     }
//     return `${kb.toFixed(1)}KB`;
//   };

//   return (
//     <div className="sms-report-page-container">
//       {loading ? (
//         <div className="sms-mark-loading-spinner"> <LoadingSpinner /> </div>
//       ) : error ? (
//         <div className="sms-error-message">{error}</div>
//       ) : (
//         <>
//           <Sidebar />
//           <div className="sms-report-content-wrapper">
//             <div className="sms-report-header">
//               <button className="sms-report-back-btn" onClick={onGoBack}>
//                 ←
//               </button>
//               <h1 className="sms-report-date">
//                 {reportData.date
//                   ? new Date(reportData.date).toLocaleDateString("en-US", {
//                     year: "numeric",
//                     month: "long",
//                     day: "numeric",
//                   })
//                   : "N/A"}
//               </h1>
//             </div>
//             <div className="sms-report-container">
//               <div className="sms-table-container">
//                 <div className="sms-report-table-wrapper">
//                   <table className="sms-report-table">
//                     <thead>
//                       <tr>
//                         <th className="sms-table-header">Partner ID</th>
//                         <th className="sms-table-header">Partner Name</th>
//                         <th className="sms-table-header">Cohort ID</th>
//                         <th className="sms-table-header">Status</th>
//                         <th className="sms-table-header">Deductions</th>
//                         <th className="sms-table-header">Payout</th>
//                         <th className="sms-table-header">Transfer Test</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {reportData && reportData.cohortScheduleResponseDto?.map((row) => (
//                         <tr key={row.payoutId || row.payoutId} className="sms-table-row">
//                           <td className="sms-table-cell">{row.franchiseeId || 'N/A'}</td>
//                           <td className="sms-table-cell">{row.payee}</td>
//                           <td className="sms-table-cell">{row.cohortId || 'N/A'}</td>
//                           <td className="sms-table-cell">
//                             <span className={`sms-generatedstatus-${(row.status || 'generated').toLowerCase()}`}>
//                               {row.status || 'Generated'}
//                             </span>
//                           </td>
//                           <td className="sms-table-cell">
//                             <TruncatedText text={row.deductions} maxLength={20} />
//                           </td>
//                           <td className="sms-table-cell">{formatCurrency(row.payout || 0)}</td>
//                           <td className="sms-table-cell">
//                             <TruncatedText text={row.transferText} maxLength={20} />
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               {/* Footer buttons */}
//               <div className="sms-report-footer">
//                 <Button
//                   onClick={onDownloadExcel}
//                   variant="outlined"
//                   fullWidth
//                   className="sms-mark-download-btn"
//                 >
//                   Download
//                 </Button>
//                 <Button
//                   onClick={handleMarkSettleClick}
//                   variant="contained"
//                   className="sms-settle-btn"
//                   fullWidth
//                 >
//                   Mark Settle
//                 </Button>
//               </div>
//             </div>
//           </div>

//           {/* Step 1: Upload UTR Dialog - Conditional Rendering */}
//           <Dialog
//             open={showMarkSettleDialog}
//             maxWidth="sm"
//             fullWidth={true}
//             // onClose={handleDialogClose}
//             className="sms-upload-dialog"
//             sx={{
//               "& .MuiDialog-paper": {
//                 width: "100%",
//                 maxWidth: "500px",
//                 borderRadius: "16px",
//                 position: "relative",
//               },
//             }}
//           >
//             <DialogTitle className="sms-upload-dialog-title">
             
//               <IconButton
//                 aria-label="close"
//                 onClick={handleDialogClose}
//                 className="sms-upload-dialog-close"
//               >
//                 <CloseIcon />
//               </IconButton>
//             </DialogTitle>

//             <DialogContent className="sms-upload-dialog-content">
//               <div className="sms-upload-dialog-title">
//                 Upload UTR
//               </div>
//               {!fileSelected && !showUploadError ? (
//                 // Before File Select - Show Upload Area
//                 <Box 
//                   className={`sms-file-upload-area ${isDragOver ? 'sms-drag-over' : ''}`}
//                   onDragOver={handleDragOver}
//                   onDragLeave={handleDragLeave}
//                   onDrop={handleDrop}
//                   onClick={() => fileInputRef.current?.click()}
//                 >
//                   <input
//                     ref={fileInputRef}
//                     id="sms-file-upload-input"
//                     type="file"
//                     accept=".xls,.xlsx"
//                     onChange={handleFileChange}
//                     className="sms-file-input-hidden"
//                   />
//                   <CloudUploadIcon className="sms-cloud-upload-icon" />
//                   <Typography className="sms-upload-title">
//                     Choose file or drag here
//                   </Typography>
//                   <Typography className="sms-upload-subtitle">
//                     Supported format: XLS only
//                   </Typography>
//                 </Box>
//               ) : (
//                 // After File Select - Show File Info
//                 <Box className="sms-file-info-box">
//                   <Box className="sms-file-info-content">
//                     <Typography className="sms-file-name">{selectedFile?.name}</Typography>
//                     <Typography className="sms-file-size">{getFileSize(selectedFile?.size)}</Typography>
//                   </Box>
//                   <button 
//                     className="sms-file-change-btn"
//                     onClick={() => {
//                       setFileSelected(false);
//                       setSelectedFile(null);
//                       setShowUploadError(false);
//                       setShowRetry(false);
//                       setUploadError(null);
//                       setShowInstructionText(true);
//                       if (fileInputRef.current) {
//                         fileInputRef.current.value = '';
//                       }
//                     }}
//                   >
//                     Change
//                   </button>
//                 </Box>
//               )}

//               {uploadLoading && (
//                 <Box className="sms-upload-loading-box">
//                   <div className="sms-upload-spinner"></div>
//                   <Typography className="sms-upload-loading-text">
//                     Uploading your file...
//                   </Typography>
//                 </Box>
//               )}

//               {uploadError && !uploadLoading && (
//                 <Alert severity="error" className="sms-upload-error-alert">
//                   {uploadError}
//                   {showRetry && (
//                     <button onClick={handleRetryUpload} className="sms-retry-btn">
//                       Try Again
//                     </button>
//                   )}
//                 </Alert>
//               )}

//               {/* Instruction Note - Only visible when no file selected and not uploading */}
//               {showInstructionText && !uploadLoading && !fileSelected && !showUploadError && (
//                 <Typography className="sms-upload-instruction-note">
//                   Please Make Sure You Are Uploading Same-Day Payout
//                   <br />
//                   (E.G. Payout Date Is 8th April 2026, So The File Must Be For 8th April 2026)
//                 </Typography>
//               )}
//             </DialogContent>

//             <DialogActions className="sms-upload-dialog-actions">
//               <Button
//                 onClick={handleDialogClose}
//                 variant="outlined"
//                 className="sms-upload-cancel-btn"
//                 style={{ display: fileSelected && !uploadLoading ? 'inline-flex' : 'none' }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 onClick={handleFileUpload}
//                 variant="contained"
//                 disabled={!selectedFile || uploadLoading}
//                 className="sms-upload-submit-btn"
//                 style={{ display: fileSelected && !uploadLoading ? 'inline-flex' : 'none' }}
//               >
//                 {uploadLoading ? 'Uploading...' : 'Upload'}
//               </Button>
//             </DialogActions>
//           </Dialog>

//           {/* Step 2: Success Dialog */}
//           <Dialog
//             open={localShowSuccessDialog || showSuccessDialog}
//             onClose={handleSuccessClose}
//             fullWidth
//             maxWidth="xs"
//             className="sms-success-dialog"
//           >
//             <DialogContent className="sms-success-dialog-content">
//               <img className="sms-success-icon" src={marksatteled} alt="success" />
//               <DialogTitle className="sms-success-title">Successful</DialogTitle>
//               <Typography className="sms-success-message">
//                 File Uploaded Successfully
//               </Typography>
//               <Button onClick={handleSuccessClose} className="sms-success-ok-btn" variant="contained">
//                 OK
//               </Button>
//             </DialogContent>
//           </Dialog>

//           {/* Step 3: Mismatch Dialog */}
//           <Dialog
//             open={localShowMismatchDialog || showMismatchDialog}
//             maxWidth="md"
//             fullWidth={true}
//             className="sms-mismatch-dialog"
//             sx={{
//               "& .MuiDialog-paper": {
//                 width: "100%",
//                 maxWidth: "550px",
//                 borderRadius: "20px",
//               },
//             }}
//           >
//             <DialogTitle className="sms-mismatch-dialog-title">
//               {mismatchData?.date || new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
//             </DialogTitle>

//             <DialogContent className="sms-mismatch-dialog-content">
//               {/* Partial Match Section */}
//               {(mismatchData?.partialMatch !== false) && (
//                 <Box className="sms-mismatch-section">
//                   <div className="sms-mismatch-header">
//                     <WarningIcon />
//                     <Typography className="sms-mismatch-title">Partial Match Found</Typography>
//                   </div>
//                   <Typography className="sms-mismatch-message">
//                     Only {mismatchData?.matchedCount || 155} of {mismatchData?.totalCount || 167} partners matched.
//                     You can upload a new matching partner's UTR later.
//                   </Typography>
//                 </Box>
//               )}

//               {/* Mismatch Amount Section */}
//               {(mismatchData?.mismatchAmount !== false) && (
//                 <Box className="sms-mismatch-section">
//                   <div className="sms-mismatch-header">
//                     <WarningIcon />
//                     <Typography className="sms-mismatch-title">Mismatch Amount Found</Typography>
//                   </div>
//                   <Typography className="sms-mismatch-message">
//                     {mismatchData?.mismatchCount || 2} partners have payout amount mismatch. 
//                     You can upload their UTR later.
//                   </Typography>

//                   <div className="sms-mismatch-list">
//                     {(mismatchData?.mismatchDetails || [
//                       { initials: "AT", name: "Alok Thori", id: "1140", expected: 32000, paid: 30000 },
//                       { initials: "RK", name: "Rohan Kumar", id: "2146", expected: 48750, paid: 45000 }
//                     ]).map((item, index) => (
//                       <div key={index} className="sms-mismatch-item">
//                         <div className="sms-mismatch-item-header">
//                           <span className="sms-mismatch-initials">{item.initials}</span>
//                           <span className="sms-mismatch-name">{item.name}</span>
//                           <span className="sms-mismatch-id">(ID: {item.id})</span>
//                         </div>
//                         <div className="sms-mismatch-amounts">
//                           <span className="sms-expected">Expected Payout: {formatCurrency(item.expected)}</span>
//                           <span className="sms-paid">Paid Payout: {formatCurrency(item.paid)}</span>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </Box>
//               )}
//             </DialogContent>

//             <DialogActions className="sms-mismatch-dialog-actions">
//               <Button onClick={handleMismatchCancel} variant="outlined" className="sms-mismatch-cancel-btn">
//                 Cancel
//               </Button>
//               <Button onClick={handleMismatchUpload} variant="contained" className="sms-mismatch-upload-btn">
//                 Upload
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </>
//       )}
//     </div>
//   );
// };

// export default ScheduleMarkSettleDownloadReportComponent;



import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  IconButton,
  Checkbox,
  FormControlLabel,
  Box
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import marksatteled from "../../../../assests/marksatteled.svg"
import CloseIcon from "@mui/icons-material/Close";
import "./ScheduleReport.css";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import * as XLSX from 'xlsx';
import debounce from 'lodash/debounce';
import { format } from 'date-fns';
import LoadingSpinner from "../../../Loading/component";
const TruncatedText = ({ text, maxLength = 20 }) => {
  const [showFullText, setShowFullText] = useState(false);

  if (!text || text.length <= maxLength) {
    return <span>{text || 'N/A'}</span>;
  }

  if (showFullText) {
    return (
      <span>
        {text}
        <button
          className="see-less-btn"
          onClick={() => setShowFullText(false)}
        >
          See Less
        </button>
      </span>
    );
  }

  return (
    <span>
      {text.substring(0, maxLength)}...
      <button
        className="see-more-btn"
        onClick={() => setShowFullText(true)}
      >
        See More
      </button>
    </span>
  );
};


const ScheduleMarkSettleDownloadReportComponent = ({
  loading,
  error,
  reportData,
  formatCurrency,
  onDownloadExcel,
  onGoBack,
  onMarkSettle,
  showMarkSettleDialog,
  setShowMarkSettleDialog,
  selectedDate,
  setSelectedDate,
  onMarkSettledConfirm,
  showSuccessDialog,
  onSuccessClose,
  selectedPayoutIds,
  setSelectedPayoutIds,
  selectAll,
  setSelectAll,
  payoutData
}) => {
  const [localSelectAll, setLocalSelectAll] = useState(false);

  // Handle select all checkbox
  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setLocalSelectAll(isChecked);

    if (isChecked) {
      // Select all payout IDs
      const allPayoutIds = reportData.cohortScheduleResponseDto?.map(item => item.payoutId) || [];
      setSelectedPayoutIds(allPayoutIds);
    } else {
      // Clear selection
      setSelectedPayoutIds([]);
    }
  };

  // Handle individual checkbox selection
  const handleCheckboxChange = (payoutId) => {
    if (selectedPayoutIds.includes(payoutId)) {
      // Remove from selection
      setSelectedPayoutIds(selectedPayoutIds.filter(id => id !== payoutId));
      setLocalSelectAll(false);
    } else {
      // Add to selection
      setSelectedPayoutIds([...selectedPayoutIds, payoutId]);

      // If all items are selected, update the select all checkbox
      const allPayoutIds = reportData.cohortScheduleResponseDto?.map(item => item.payoutId) || [];
      if (selectedPayoutIds.length + 1 === allPayoutIds.length) {
        setLocalSelectAll(true);
      }
    }
  };

  // Update local select all when selectedPayoutIds changes
  useEffect(() => {
    const allPayoutIds = reportData.cohortScheduleResponseDto?.map(item => item.payoutId) || [];
    setLocalSelectAll(selectedPayoutIds.length === allPayoutIds.length && allPayoutIds.length > 0);
  }, [selectedPayoutIds, reportData]);

  return (
    <div className="report-page-container">
      {loading ? (
        <div className="mark-loading-spinner"> <LoadingSpinner /> </div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : (
        <>
          <Sidebar />
          <div className="report-content-wrapper">
            <div className="report-header">
              <button className="report-back-btn" onClick={onGoBack}>
                ←
              </button>
              <h1 className="report-date">
                {reportData.date
                  ? new Date(reportData.date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                  : "N/A"}
              </h1>
            </div>
            <div className="report-container">
              <div className="table-container">
                <div className="report-table-wrapper">
                  <table className="report-table">
                    <thead>
                      <tr>
                        <th>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={localSelectAll}
                                onChange={handleSelectAll}
                                disabled={!reportData.cohortScheduleResponseDto || reportData.cohortScheduleResponseDto.length === 0}
                              />
                            }
                            label="Select All"
                          />
                        </th>
                        <th>Partner ID</th>
                        <th>Partner Name</th>
                        <th>Cohort ID</th>
                        <th>Status</th>
                        <th>Deductions</th>
                        <th>Payout</th>
                        <th>Transfer Test</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData && reportData.cohortScheduleResponseDto?.map((row) => (
                        <tr key={row.payoutId || row.payoutId}>
                          <td>
                            <Checkbox
                              checked={selectedPayoutIds.includes(row.payoutId)}
                              onChange={() => handleCheckboxChange(row.payoutId)}
                            />
                          </td>
                          <td>{row.franchiseeId || 'N/A'}</td>

                          <td>

                            {row.payee}
                          </td>
                           <td>

                            {row.cohortId || 'N/A'}
                          </td>
                          <td>
                            <span className={`generatedstatus-${(row.status || 'generated').toLowerCase()}`}>
                              {row.status || 'Generated'}
                            </span>
                          </td>
                          <td>
                            <TruncatedText text={row.deductions} maxLength={20} />

                          </td>
                          <td>{formatCurrency(row.payout || 0)}</td>
                          <td>
                            <TruncatedText text={row.transferText} maxLength={20} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Footer buttons */}
              <div className="report-footer">
                <Button
                  onClick={onDownloadExcel}
                  variant="outlined"
                  fullWidth
                  className="mark-download-btn"
                >
                  Download
                </Button>
                <Button
                  onClick={() => onMarkSettle(selectedPayoutIds)}
                  variant="contained"
                  color="secondary"
                  className="settle-btn"
                  fullWidth
                  disabled={selectedPayoutIds.length === 0}
                >
                  Mark Settle ({selectedPayoutIds.length})
                </Button>
              </div>
            </div>
          </div>

          {/* Mark Settle Dialog */}
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Dialog
              open={showMarkSettleDialog}
              maxWidth="sm"
              fullWidth={true}
              sx={{
                "& .MuiDialog-paper": {
                  width: "100%",
                  maxWidth: "500px",
                  minHeight: "280px",
                  position: "relative",
                  borderRadius: "8px",
                },
              }}
            >
              <DialogTitle
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "1.25rem",
                  padding: "20px 24px 16px",
                  position: "relative",

                }}
              >
                Mark Settle
                <IconButton
                  aria-label="close"
                  onClick={() => setShowMarkSettleDialog(false)}
                  sx={{
                    position: "absolute",
                    right: 16,
                    top: 16,
                    color: "#666"
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent sx={{ padding: "24px" }}>
                <Box sx={{ marginBottom: "20px" }}>
                  <DatePicker
                    label="Select Date to Mark this Payout as Settled"
                    value={selectedDate}
                    onChange={(newValue) => setSelectedDate(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        margin="normal"
                        sx={{
                          "& .MuiInputLabel-root": {
                            fontSize: "14px"
                          },
                          "& .MuiInputBase-root": {
                            fontSize: "14px"
                          }
                        }}
                      />
                    )}
                  />
                </Box>
                <Typography variant="body2" sx={{
                  mt: 2,
                  textAlign: "center",
                  fontSize: "14px",
                  color: "#666"
                }}>
                  Selected Payouts: {selectedPayoutIds.length}
                </Typography>
              </DialogContent>

              <DialogActions sx={{
                justifyContent: "center",
                padding: "16px 24px 24px",

              }}>
                <Button
                  onClick={onMarkSettledConfirm}
                  color="success"
                  variant="contained"
                  disabled={!selectedDate || selectedPayoutIds.length === 0}
                  sx={{
                    width: "150px",
                    padding: "8px 24px",
                    fontSize: "14px",
                    fontWeight: "600"
                  }}
                >
                  DONE
                </Button>
              </DialogActions>
            </Dialog>

            {/* Success Dialog */}
            <Dialog
              open={showSuccessDialog}
              onClose={onSuccessClose}
              fullWidth
              maxWidth="xs"
              sx={{
                "& .MuiDialog-paper": {
                  borderRadius: "8px",
                  padding: "0",
                }
              }}
            >
              <DialogContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  padding: "32px 24px 24px",
                }}
              >
                <img
                  style={{
                    height: "70px",
                    width: "70px",
                    marginBottom: "20px"
                  }}
                  src={marksatteled}
                  alt="success"
                />
                <DialogTitle sx={{
                  textAlign: "center",
                  padding: "0",
                  marginBottom: "8px",
                  fontSize: "1.25rem",
                  fontWeight: "bold"
                }}>
                  Marked Settled
                </DialogTitle>
                <Typography sx={{
                  marginBottom: "24px",
                  fontSize: "14px",
                  color: "#666"
                }}>
                  {selectedPayoutIds.length} payout(s) have been marked as settled.
                </Typography>
                <Button
                  onClick={onSuccessClose}
                  sx={{
                    backgroundColor: "#14AE78",
                    color: "white",
                    padding: "8px 24px",
                    fontSize: "14px",
                    fontWeight: "600",
                    width: "150px",
                    "&:hover": {
                      backgroundColor: "#119966"
                    }
                  }}
                  variant="contained"
                >
                  OK
                </Button>
              </DialogContent>
            </Dialog>
          </LocalizationProvider>
        </>
      )}
    </div>
  );
};

export default ScheduleMarkSettleDownloadReportComponent;